import { articles } from "@/mocks/manga";

export default function Articles() {
  return (
    <section id="articles" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-500">
              <span className="h-px w-8 bg-primary-400" aria-hidden="true"></span>
              热门内容推荐
            </p>
            <h2 className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              深度梳理 <span className="text-primary-600">角色与CP</span> 的专题文章
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-7 text-foreground-700">
            更多人物介绍与感情线细节，都在这些专题里帮你一次讲透。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {articles.map((a) => (
            <article
              key={a.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden">
                <img
                  src={a.image}
                  alt={`恋爱辅助器漫画专题：${a.title}`}
                  className="aspect-[16/10] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-3 py-1 text-xs font-semibold text-white">
                  {a.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                  {a.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-700">{a.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {a.read} 阅读
                  </span>
                  <a
                    href="#articles"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700"
                  >
                    阅读全文
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}